import { FGTextInput, FieldGroup, useApiEffect } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";
import * as Yup from "yup";

import { DogBreederApi, GetDogBreederParameters, PersonApi } from "../../../../api";
import { SmallFormGenerator, FGSRSHDateMaskInput } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { PersonBreederDogsPage } from "./PersonBreederDogsPage";
import { PersonKennelsPage } from "./PersonKennelsPage";
import { PersonBreederChart } from "./PersonBreederChart";

export interface IPersonBreederPageProps {
  personId: number;
  editMode: boolean;
}

const StyledContainer = styled.div`
  & > * {
    margin-top: 2rem;
  }
`;

export const PersonBreederPage: React.FunctionComponent<IPersonBreederPageProps> = ({ personId, editMode }) => {
  const { t } = useTl();
  const api = useApiService(DogBreederApi);
  const personApi = useApiService(PersonApi);
  const [isWaloon] = useApiEffect(() => personApi.isPersonWaloon(personId));
  const { data, loading, saving, saveItem } = useCrudApi(
    {
      getApiFn: () => api.getBreeder(new GetDogBreederParameters({ personId: personId })),
      saveApiFn: (d) => api.saveBreeder(d),
      deleteApiFn: (d) => {},
    },
    [personId]
  );

  const FormSchema = React.useMemo(() => {
    return Yup.object().shape({
      hkNumber: isWaloon?.value ? Yup.string().nullable().required(t(ETLCodes.Required)) : Yup.string().nullable(),
      webSiteUri: Yup.string().nullable(),
      firmNameInvoicing: Yup.string().nullable(),
      bannedFrom: Yup.date().nullable(),
      bannedTo: Yup.date().nullable(),
    });
  }, [isWaloon, t]);

  return (
    <>
      <SmallFormGenerator
        initialValues={data}
        onSubmit={saveItem}
        editMode={editMode}
        loading={loading}
        validationSchema={FormSchema}
        showDeleteButton={false}
        saving={saving}
      >
        <FieldGroup fieldsetProps={{ title: t(ETLCodes.Breeder) }}>
          <FGTextInput name="hkNumber" label={t(ETLCodes.HK)} />
          <FGTextInput name="vatNumber" label={t(ETLCodes.VATNumber)} />
          <FGTextInput name="firmNameInvoicing" label={t(ETLCodes.firmNameInvoicing)} />
          <FGTextInput name="webSiteUri" label={t(ETLCodes.WebsiteAdresse)} />
          <FGSRSHDateMaskInput name="bannedFrom" label={t(ETLCodes.BannedFrom)} />
          <FGSRSHDateMaskInput name="bannedTo" label={t(ETLCodes.BannedTo)} />
        </FieldGroup>
      </SmallFormGenerator>
      {data && data.personId > 0 && (
        <StyledContainer>
          <PersonBreederDogsPage personId={data.personId} />
          <PersonKennelsPage personId={data.personId} />
          <PersonBreederChart personId={data.personId} />
        </StyledContainer>
      )}
    </>
  );
};
